<template>
  <v-container fluid>
    <v-row>
      <v-col>
        <div class="mx-auto" style="max-width: 80vh; height: calc(70vh - 15px)">
          <v-img
            class="mx-auto"
            src="../assets/logo.svg"
            height="200px;"
            style="width: 40vh !important; margin-top: 10vh"
          ></v-img>
          <v-card-title primary-title></v-card-title>
          <v-form>
            <v-text-field
              prepend-icon="mdi-account"
              v-model="nome"
              :label="t('usuario')"
            ></v-text-field>
            <v-text-field
              prepend-icon="mdi-lock"
              v-model="senha"
              name="Password"
              :label="t('senha')"
              type="password"
            ></v-text-field>

            <v-card-actions>
              <v-btn primary large block @click="submit()">{{
                t("entrar")
              }}</v-btn>
            </v-card-actions>
          </v-form>
          <b-alert show variant="danger" v-if="error">{{ error }}</b-alert>
          <v-checkbox
            v-model="salvarCredenciais"
            :label="t(`salvarCredenciais`)"
          ></v-checkbox>
        </div>
      </v-col>
    </v-row>
    <span style="font-size: 0.8em; float: right">{{ VERSION }}</span>

    <!-- <v-btn icon @click="setModalConfig(true)">
      <v-icon class="icon">mdi-cog</v-icon>
    </v-btn>-->
  </v-container>
</template>
   
<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";

export default {
  name: "Login",
  data() {
    return {
      VERSION: require("../../package.json").version,
      valid: false,
      e1: false,
      senha: "",
      error: ``,
      salvarCredenciais: false,
      passwordRules: [(v) => !!v || "Password is required"],
      nome: "",
      emailRules: [
        (v) => !!v || "E-mail is required",
        // (v) => /^\w+([\\.-]?\\w+)*@\w+([\.-]?\w+)*(\\.\\w{2,3})+$/.test(v) || 'E-mail must be valid'
      ],
    };
  },
  created() {
    if (localStorage.getItem(`credenciais`)) {
      let credenciais = JSON.parse(localStorage.getItem(`credenciais`));
      this.nome = credenciais.nome;
      this.senha = credenciais.senha;
      this.salvarCredenciais = true;
    }
    if (!localStorage.getItem(`config`)) {
      this.setModalConfig(true);
    }
    // if(this.token) this.$router.push("/main");
  },
  computed: {
    ...mapState("auth", {
      token: (state) => state.token,
      status: (state) => state.status,
      isLogged: (state) => state.isLogged,
    }),
  },
  watch: {
    status() {
      // if (this.status === "success") {
      //   this.$router.push("/home");
      // }
    },
    isLogged() {
      // if (nw) {
      //   this.$router.push("/home");
      // }
    },
  },
  methods: {
    ...mapActions("auth", ["login", "getLocalStorage", "setLocalStorage"]),
    ...mapActions("xc", ["setModalConfig"]),
    async submit() {
      const data = {
        nome: this.nome,
        senha: this.senha,
      };
      try {
        await this.login(data);
        if (this.salvarCredenciais) {
          localStorage.setItem(
            `credenciais`,
            JSON.stringify({ nome: this.nome, senha: this.senha })
          );
        } else {
          localStorage.removeItem(`credenciais`);
        }
        this.$router.push("/home");
      } catch (error) {
        this.error = error.msg;
        console.error(error);
      }
    },
    clear() {},
  },
};
</script>
<style>
</style>